import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

import img1 from "../../Assets/3rd_slider/Acne Pimple.png";
import img2 from "../../Assets/3rd_slider/Dengue & Malaria.png";
import img3 from "../../Assets/3rd_slider/Fatty Liver.png";
import img4 from "../../Assets/3rd_slider/Hair Fall.png";
import img5 from "../../Assets/3rd_slider/Sexual Concern.png";
import Fourth_slider from "./Fourth_slider";

const images = [img1, img2, img3, img4, img5];

const Third_slider = () => {

    return (

        <> 

        <div className="w-full bg-white py-10">
            <div className="max-w-7xl mx-auto px-4">

                {/* Header */}
                <div className="flex items-center justify-between mb-6">
                    <h2 className="text-[26px] font-medium text-black">
                        Health Concern
                    </h2>

                    {/* Arrows (desktop only – UI only) */}
                    <div className="hidden md:flex gap-3">
                        <button className="w-10 h-10 rounded-full bg-teal-700 flex items-center justify-center text-white">
                            <ChevronLeft size={18} />
                        </button>
                        <button className="w-10 h-10 rounded-full bg-teal-700 flex items-center justify-center text-white">
                            <ChevronRight size={18} />
                        </button>
                    </div>
                </div>

                {/* Slider */}
                <div
                    className="
            flex gap-6
            overflow-x-auto
            lg:overflow-visible
            scrollbar-hide
          "
                >
                    {images.map((img, index) => (
                        <div
                            key={index}
                            className="
      flex-shrink-0
      w-[210px]
      h-[210px]
      rounded-[15px]
      overflow-hidden
      flex
      items-center
      justify-center
      bg-white
    "
                        >
                            <img
                                src={img}
                                alt="health"
                                className="
        w-full
        h-full
        object-contain
        opacity-100
      "
                            />
                        </div>
                    ))}


                </div>
            </div>
        </div>
        {/* <Fourth_slider/> */}
        </>
    );
};

export default Third_slider;
